import { styled } from 'styled-components'
import { Block } from 'suomifi-ui-components'
import media from 'common-ui-components/src/vtj/theme/media'
import {
  NonEditableField,
  StyledTextInput,
} from 'todistukset-ui/src/vtj/components/order-wizard/CommonFormComponents.sc'

export const Columns = styled(Block)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-top: ${({ theme }) => theme.spacing.l};
  grid-gap: 0 ${({ theme }) => theme.spacing.l};

  ${StyledTextInput} {
    margin: 0;
  }

  ${media.mobileAndTablet} {
    grid-template-columns: 1fr;
    grid-gap: 0px;

    ${StyledTextInput} + ${StyledTextInput} {
      margin-top: ${({ theme }) => theme.spacing.s};
    }
  }

  & > ${NonEditableField} {
    margin: ${({ theme }) => theme.spacing.xs} 0;
  }
`

export const TextInputColumns = styled(Columns)`
  gap: ${({ theme }) => theme.spacing.m};

  ${media.mobileAndTablet} {
    gap: 0;
  }
`
